var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600" },
      model: {
        value: _vm.selectGroupDialogVisible,
        callback: function ($$v) {
          _vm.selectGroupDialogVisible = $$v
        },
        expression: "selectGroupDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.t("selectGroup")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.selectGroupDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          { staticClass: "ma-0 pa-0 mt-2 mb-14" },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { id: "store_list", cols: "12" },
                              },
                              [
                                _vm.fetchLoading == false
                                  ? _vm._l(
                                      _vm.storeGroupList,
                                      function (item, index) {
                                        return _c(
                                          "v-col",
                                          {
                                            key: index,
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass:
                                                  "ma-0 pa-3 pt-1 pb-1",
                                                staticStyle: {
                                                  "border-bottom":
                                                    "1px solid #4A4A4A",
                                                },
                                                attrs: { align: "center" },
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.checked,
                                                      expression:
                                                        "item.checked",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: "check_box",
                                                    type: "checkbox",
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      item.checked
                                                    )
                                                      ? _vm._i(
                                                          item.checked,
                                                          null
                                                        ) > -1
                                                      : item.checked,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a = item.checked,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              item,
                                                              "checked",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              item,
                                                              "checked",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          item,
                                                          "checked",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass:
                                                      "ma-0 pa-0 ml-3",
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                    },
                                                    attrs: {
                                                      cols: "auto",
                                                      align: "left",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.groupName) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    )
                                  : [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "ma-0 pa-7",
                                          attrs: {
                                            cols: "12",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c("v-progress-circular", {
                                            attrs: {
                                              indeterminate: "",
                                              color: "white",
                                              width: 4,
                                              size: 30,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-2",
                                attrs: {
                                  width: "8rem",
                                  height: "auto",
                                  id: "grey_btn",
                                  elevation: "0",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectGroupDialogVisible = false
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.t("back")) + " ")]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-2 ml-2",
                                attrs: {
                                  width: "8rem",
                                  height: "auto",
                                  id: "blue_btn",
                                  elevation: "0",
                                  loading: _vm.addLoading,
                                },
                                on: { click: _vm.requestAdd },
                              },
                              [_vm._v(" " + _vm._s(_vm.t("add")) + " ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("AddGroupResultDialog", {
        attrs: {
          dialogVisible: _vm.addGroupDialogVisible,
          msgList: _vm.resultMessageList,
        },
        on: { visible: _vm.addGroupDialogVisibleFunc },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }